import { GET_BY_ID, REMOVE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IInternalContact, type IMergeAsyncExecStatusResult, internalContactProperties, internalContactsManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { getDobjId } from '@/services/data-object-helper';

import { SET_MATCHES } from './mutations';

export const DELETE_IN_STORE = 'deleteInStore';
export const MERGE = 'merge';
export const RETRIEVE_MATCHES = 'retrieveMatches';

function removeDuplicate(list: string[]): string[] {
    const newList = [list[0]];
    for (const el of list) {
        if (!newList.includes(el)) {
            newList.push(el);
        }
    }
    return newList;
}

export const actions: ActionTree<IInternalContact, unknown> = {
    [DELETE_IN_STORE](context, { dobjId }: { dobjId: number }): void {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId });
    },
    async [MERGE](
        context,
        { target, toMerge, properties }: { target: IInternalContact; toMerge: IInternalContact; properties: string }
    ): Promise<IMergeAsyncExecStatusResult> {
        const dataObject: IInternalContact = {
            dobjId: target.dobjId,
            salutation: target.salutation ?? toMerge.salutation,
            phones: (target.phones ? removeDuplicate(target.phones.concat(toMerge.phones ?? [])).slice(0, 5) : toMerge.phones) ?? [],
            address:
                target.address?.country || target.address?.city?.length || target.address?.zip || target.address?.state || target.address?.address1
                    ? {
                          country: getDobjId(target.address?.country),
                          address1: target.address?.address1,
                          city: target.address?.city,
                          zip: target.address?.zip,
                          state: target.address?.state
                      }
                    : {
                          country: getDobjId(toMerge.address?.country),
                          address1: toMerge.address?.address1,
                          city: toMerge.address?.city,
                          zip: toMerge.address?.zip,
                          state: toMerge.address?.state
                      },
            linkedInUrl: target.linkedInUrl?.length ? target.linkedInUrl : toMerge.linkedInUrl,
            urls: target.urls?.length ? target.urls : toMerge.urls,
            description: target.description
                ? toMerge.description
                    ? `${target.description}<p></p>${toMerge.description}`
                    : target.description
                : toMerge.description
        };

        const statusId: string = await internalContactsManager.merge(dataObject, toMerge.dobjId, properties);
        return internalContactsManager.getExecutionManager().waitForStatus(statusId);
    },
    async [RETRIEVE_MATCHES](context, { contactId }: { contactId: number }): Promise<void> {
        const contact: IInternalContact = context.getters[GET_BY_ID](contactId);
        // we retrieve the matches search result and extract only the matches that are not the original object
        const matches = (await internalContactsManager.retrieveMatches(contact.dobjPrettifiedBusinessWiseId, internalContactProperties.DETAILS))
            ?.map((el) => {
                return el.match;
            })
            .filter((match) => {
                return match?.dobjId !== contactId;
            });
        context.commit(SET_MATCHES, {
            contactId,
            matches
        });
    }
};
